import React, {useEffect} from 'react';
import {useStores} from "../../../stores/Context";
import {observer} from "mobx-react";
import ParametreSvg from "../../../boiteAOutils/SVG/ParametreSvg";
import FlecheRevenirSvg from "../../../boiteAOutils/SVG/FlecheRevenirSvg";
import FlecheCercleSvg from "../../../boiteAOutils/SVG/FlecheCercleSvg";
import PlusSvg from "../../../boiteAOutils/SVG/PlusSvg";
import {useParams} from "react-router-dom";
import {createAxiosEntrepriseInstance} from "../../../axiosEntreprise";
import axios from "axios";
import ModalPrimary from "../../../boiteAOutils/ModalPrimary";

const WidgetConsignesBtn = observer(() => {
    const {ent} = useParams();
    const {consignesStore, uiStore, bibliothequeImagesStore, widgetStore} = useStores();
    const [nbMessages, setNbMessages] = React.useState(0);
    const [showModal, setShowModal] = React.useState(false);
    const cookieEntreprise = widgetStore.getCookie("currentEntrepriseInfos");
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();

    const axiosEntrepriseInstance = createAxiosEntrepriseInstance(ent);

    const hasBibliothequeImages = Array.isArray(entrepriseInfos.phidgetsActives) && entrepriseInfos.phidgetsActives.includes("WidgetBibliothequeImages");

    useEffect(() => {
        recupListConsignes();
    })

    const recupListConsignes = async () => {
        try {
            const res = await axios.get(
                process.env.REACT_APP_API_URL + '/api/allConsignesByIdTotem/' + widgetStore.idTotem,
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            );
            console.log('recupListConsignes::res', res.data);
            setNbMessages(res.data.length);
            return res.data.length;
        } catch (error) {
            console.error('Erreur lors de la récupération des consignes:', error);
            return 0;
        }
    }

    const handleGoHome = (event) => {
        event.preventDefault();
        uiStore.closeConsultingIndicateurWidget();
        bibliothequeImagesStore.handleCloseModuleImage();
    }

    const handleBtnViewHome = () => {
        consignesStore.handleViewHome()
    }

    const handleBtnViewAdd = () => {
        recupListConsignes().then((res) => {
            if (res >= 5 && entrepriseInfos.subscriber === false) {
                setShowModal(true);
            } else {
                consignesStore.handleViewAddConsigne();
            }
        })
    }

    const handleBtnViewHistory = () => {
        consignesStore.handleViewHistory()
    }

    const handleBtnViewGestion = () => {
        consignesStore.handleViewGestion()
    }

    return (
        <div className={"navBarWidgetBtnContent"}>

            <div className={"widgetsNavBarContentIcons"} onClick={handleGoHome}>
                <FlecheRevenirSvg width={40} height={40} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Revenir</span>
            </div>

            <div className={"widgetsNavBarContentIcons"} onClick={() => {
                bibliothequeImagesStore.onResetImageModule();
                handleBtnViewAdd();
            }}>
                <div className={"navBarWidgetBtnAdd"}>
                    <svg width="40" height="39" viewBox="0 0 40 39" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 4.875V34.125" stroke="white" strokeWidth="4"/>
                        <path d="M5.37598 19.5H34.6245" stroke="white" strokeWidth="4"/>
                    </svg>
                </div>
            </div>
            
            <div className={"widgetsNavBarContentIcons"} onClick={handleBtnViewGestion}>
                <ParametreSvg width={36} height={39} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Paramètres</span>
            </div>

            <div className={"widgetsNavBarContentIcons"} onClick={handleBtnViewHistory}>
                <FlecheCercleSvg width={40} height={40} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Archives</span>
            </div>
            {showModal ? (
                <ModalPrimary
                    textTitle="Limite atteinte"
                    textComment="Vous avez atteint la limite de 5 consignes. Passez à l’abonnement pour en ajouter davantage."
                    textBtnValidate="OK"
                    textBtnCancel="Annuler"
                    onCancel={() => setShowModal(false)}
                    textURL="S'abonner"
                    URL="https://www.seizo.fr/pricing-plans/list"
                />
            ) : ''}
        </div>
    );
});

export default WidgetConsignesBtn;